import classNames from "classnames";

const LandingPageComponentWrapper = (props) => {
    return <div className={classNames("flex justify-center w-full",props?.bg)}>
        <div className="container flex justify-center">
            <div className={classNames("max-w-6xl", props?.isFlex1 ? "flex-1" : "")}>
                {props?.children}
            </div>
        </div>
    </div>
}

export default LandingPageComponentWrapper;